module.exports = __webpack_public_path__ + "static/media/messageDay.fa737893.svg";